import { useBrowsePresetApi } from '@aibees/shared/api';
import { useEffect } from 'react';
import { useSavedSearchMetadataStore } from '../../store/saved-search-metadata';
import { ElephantPresetType } from '../../types';

export function useSavedSearchMetadata() {
  const { setMetadata } = useSavedSearchMetadataStore();

  const companyApi = useBrowsePresetApi({
    type: ElephantPresetType.COMPANY_SAVED_SEARCH,
  });

  const peopleApi = useBrowsePresetApi({
    type: ElephantPresetType.PEOPLE_SAVED_SEARCH,
  });

  useEffect(() => {
    if (companyApi.data || peopleApi.data) {
      const companyCount = companyApi.data?.content?.length || 0;
      const peopleCount = peopleApi.data?.content?.length || 0;

      setMetadata({
        [ElephantPresetType.COMPANY_SAVED_SEARCH]: companyCount,
        [ElephantPresetType.PEOPLE_SAVED_SEARCH]: peopleCount,
      });
    }
  }, [companyApi.data, peopleApi.data, setMetadata]);

  return {
    isLoading: companyApi.isLoading || peopleApi.isLoading,
  };
}
